import {
  DrawerCloseButton,
  HStack,
  StackProps,
  useColorModeValue,
  useDisclosure,
} from "@chakra-ui/react";
import { lazy, Suspense } from "react";
import { useGetUserLoginStore } from "../../store/useGetUserLoginStore";
import { useDividerColor } from "../../themes/colors";
import { UserHeaderDrawer } from "../header/UserHeaderDrawer";
import { SpinnerLoading } from "../spinner/SpinnerLoading";

const ListAccountDrawer = lazy(() => import("./ListAccountDrawer"));

interface Props extends StackProps {}

export const SwitchAccountDrawer = ({ ...rest }: Props) => {
  const { currentActiveUser } = useGetUserLoginStore();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const dividerColor = useDividerColor();

  return (
    <>
      <HStack
        cursor={"pointer"}
        justify={"space-between"}
        align={"center"}
        borderBottomWidth={"1px"}
        borderBottomColor={dividerColor}
        onClick={onOpen}
        position={"sticky"}
        top={"0px"}
        pb={"10px"}
        pt={"40px"}
        bg={useColorModeValue("white", "black")}
        {...rest}
      >
        <DrawerCloseButton
          borderColor={useColorModeValue("black", "white")}
          borderWidth={"1px"}
          rounded={"full"}
          size={"sm"}
          mr={"-10px"}
          mt={"10px"}
        />

        {currentActiveUser && <UserHeaderDrawer />}
      </HStack>

      <Suspense fallback={<SpinnerLoading />}>
        <ListAccountDrawer
          currentActiveUser={currentActiveUser}
          isOpen={isOpen}
          onOpen={onOpen}
          onClose={onClose}
          children={undefined}
        />
      </Suspense>
    </>
  );
};
